import { Home } from '@lmc/ts-common'
import { NavigationModal } from '@lmc/ui-kit'
import { Alert } from 'antd'
import { Trans, useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { Text } from '@lmc/ui-kit/src/general'
import { InfoCircleFilled } from '@ant-design/icons'
import styled from 'styled-components'
import { lowerCase } from 'lodash'

type DeleteAddressModalProps = {
  showModal: boolean
  setShowModal: (value: boolean) => void
}

const DeleteAddressModal = ({
  showModal,
  setShowModal,
}: DeleteAddressModalProps) => {
  const { t } = useTranslation()

  const preferredPeopleNominative = useSelector(
    (state: { global: { home: Home } }) =>
      state.global.home.preferredPeopleNominative
  )

  return (
    <NavigationModal
      modalTitle={t('DELETE_ADDRESS_TITLE')}
      modalContentText={t('DELETE_ADDRESS_DESCRIPTION')}
      modalConfirmText={t('OK')}
      showPrompt={showModal}
      confirmNavigation={() => setShowModal(false)}
      cancelNavigation={() => setShowModal(false)}
      confirmButtonProps={{ variant: 'primary' }}
    >
      <Alert
        message={<Text weight="bold">{t('QUICK_TIPS')}</Text>}
        description={
          <Content>
            <Text>{t('ADDRESS_MAKE_SURE')}</Text>
            <ol>
              <Text>
                <li>
                  <Trans
                    i18nKey="ADDRESS_STEP_1"
                    values={{
                      nominative: lowerCase(preferredPeopleNominative),
                    }}
                    components={{ strong: <strong /> }}
                  />
                </li>
              </Text>
              <Text>
                <li>
                  <Trans
                    i18nKey="ADDRESS_STEP_2"
                    components={{ strong: <strong /> }}
                  />
                </li>
              </Text>
              <Text>
                <li>
                  <Trans
                    i18nKey="ADDRESS_STEP_3"
                    components={{ strong: <strong /> }}
                  />
                </li>
              </Text>
            </ol>
          </Content>
        }
        type="info"
        showIcon
        icon={<InfoIconStyled />}
      />
    </NavigationModal>
  )
}

const Content = styled.div`
  display: flex;
  flex-direction: column;
`

const InfoIconStyled = styled(InfoCircleFilled)`
  width: 16px;
  height: 16px;
  margin-top: 4px;
`

export default DeleteAddressModal
